import { render, staticRenderFns } from "./MedicalInfo.vue?vue&type=template&id=66f30968&scoped=true"
import script from "./MedicalInfo.vue?vue&type=script&lang=js"
export * from "./MedicalInfo.vue?vue&type=script&lang=js"
import style0 from "./MedicalInfo.vue?vue&type=style&index=0&id=66f30968&prod&lang=css"
import style1 from "./MedicalInfo.vue?vue&type=style&index=1&id=66f30968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f30968",
  null
  
)

export default component.exports